import React from 'react'
import TimerLib from 'react-compound-timer'

type Props = {
  initial?: Date
}

const Timer: React.FC<Props> = ({ initial }) => {
  const seconds = initial ? new Date().getTime() - initial.getTime() : 0

  return (
    <time>
      <TimerLib
        initialTime={seconds}
        formatValue={value => `${value < 10 ? `0${value}` : value}`}
      >
        <TimerLib.Minutes />
        :
        <TimerLib.Seconds />
      </TimerLib>
    </time>
  )
}

export default Timer

type PropsStatic = {
  dateA: Date
  dateB: Date
}

export const TimerStatic: React.FC<PropsStatic> = ({ dateA, dateB }) => {
  const seconds = dateB.getTime() - dateA.getTime()

  return (
    <time>
      <TimerLib
        initialTime={seconds}
        formatValue={value => `${value < 10 ? `0${value}` : value}`}
        startImmediately={false}
      >
        <TimerLib.Minutes />
        :
        <TimerLib.Seconds />
      </TimerLib>
    </time>
  )
}
